export default __webpack_public_path__ + "static/media/ANY.c9d05bd3.png";